(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  root.ComparisonUrlState = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  var handlePattern = /^[a-z0-9](?:[a-z0-9-]{0,253}[a-z0-9])?$/;
  var typePattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

  function unique(values) {
    return values.filter(function (value, index) {
      return values.indexOf(value) === index;
    });
  }

  function productHandle(product, baseUrl) {
    if (!product || typeof product.url !== 'string') return null;

    try {
      var pathname = new URL(product.url, baseUrl).pathname;
      var match = pathname.match(/\/products\/([^/]+)/);
      var handle = match ? decodeURIComponent(match[1]).toLowerCase() : '';
      return handlePattern.test(handle) ? handle : null;
    } catch (error) {
      return null;
    }
  }

  function productIndex(products, baseUrl) {
    return Object.keys(products || {}).reduce(function (index, productName) {
      var handle = productHandle(products[productName], baseUrl);
      if (handle && !index[handle]) index[handle] = productName;
      return index;
    }, {});
  }

  function parseHandles(value) {
    return unique(String(value || '').split(',').map(function (handle) {
      return handle.trim().toLowerCase();
    }).filter(function (handle) {
      return handlePattern.test(handle);
    })).slice(0, 100);
  }

  function read(search, productsByType, options) {
    var settings = options || {};
    var maximum = settings.maximum || 5;
    var types = Object.keys(productsByType || {});
    var defaultType = types.indexOf(settings.defaultType) >= 0 ? settings.defaultType : types[0];
    var parameters;

    try {
      parameters = new URLSearchParams(search || '');
    } catch (error) {
      return null;
    }

    if (!parameters.has('type') && !parameters.has('products')) return null;

    var requestedType = String(parameters.get('type') || '').toLowerCase();
    var handles = parseHandles(parameters.get('products'));
    var indexes = types.reduce(function (result, type) {
      result[type] = productIndex(productsByType[type], settings.baseUrl);
      return result;
    }, {});
    var type = typePattern.test(requestedType) && types.indexOf(requestedType) >= 0
      ? requestedType
      : null;

    if (!type && handles.length) {
      var scores = types.map(function (candidate) {
        return {
          type: candidate,
          count: handles.filter(function (handle) {
            return Boolean(indexes[candidate][handle]);
          }).length
        };
      });
      var highest = Math.max.apply(null, scores.map(function (score) { return score.count; }));
      var matches = scores.filter(function (score) { return score.count === highest; });
      if (highest > 0 && matches.length === 1) type = matches[0].type;
    }

    type = type || defaultType;

    return {
      type: type,
      productKeys: type ? handles.map(function (handle) {
        return indexes[type][handle];
      }).filter(Boolean).slice(0, maximum) : []
    };
  }

  function createRelativeUrl(href, type, productKeys, products, options) {
    var settings = options || {};
    var maximum = settings.maximum || 5;
    var url = new URL(href, settings.baseUrl);
    var handles = unique((productKeys || []).map(function (productKey) {
      return productHandle(products && products[productKey], settings.baseUrl || url.origin);
    }).filter(Boolean)).slice(0, maximum);

    if (typePattern.test(type || '')) {
      url.searchParams.set('type', type);
    } else {
      url.searchParams.delete('type');
    }

    if (handles.length) {
      url.searchParams.set('products', handles.join(','));
      url.search = url.search.replace(/([?&]products=)[^&]*/, function (match, prefix) {
        return prefix + handles.map(encodeURIComponent).join(',');
      });
    } else {
      url.searchParams.delete('products');
    }

    return url.pathname + url.search + url.hash;
  }

  function replace(historyObject, href, type, productKeys, products, options) {
    var relativeUrl = createRelativeUrl(href, type, productKeys, products, options);
    historyObject.replaceState(historyObject.state, '', relativeUrl);
    return relativeUrl;
  }

  return {
    createRelativeUrl: createRelativeUrl,
    productHandle: productHandle,
    read: read,
    replace: replace
  };
});
